import type { ReactElement, Ref } from 'react';
import { Button } from 'react-aria-components';
import { Icon } from '../ui/Icon';

/**
 * The header's Feedback button (APP-104 §3.1). Below 1200 px it keeps only its icon; the words
 * stay in the accessible name. It carries no `data-feedback-ui`: it stays in the screenshot.
 */
export function FeedbackButton({
  onPress,
  className,
  labelClassName,
  ref,
}: {
  onPress: () => void;
  className?: string;
  /** The visible word; the header hides it in narrow windows. */
  labelClassName?: string;
  ref?: Ref<HTMLButtonElement>;
}): ReactElement {
  return (
    <Button
      ref={ref}
      {...(className !== undefined && { className })}
      onPress={onPress}
      aria-haspopup="dialog"
      aria-label="Send feedback"
      data-testid="feedback-button"
    >
      <Icon name="message" size={18} />
      <span {...(labelClassName !== undefined && { className: labelClassName })}>Feedback</span>
    </Button>
  );
}
